import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ApiCall } from '../CommonComponents/CustomHooks';
import Loader from '../CommonComponents/Loader';
import { SetSession } from '../CommonComponents/cryptoUtils';

const Authenticate = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [pageStatus, setPageStatus] = useState(false);
    const [Response, setResponse] = useState({});
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const ValidateId = queryParams.get('id');
    const source = queryParams.get('source');
    const RequestID = queryParams.get('requestId');

    const AuthenticateSSOLogin = async () => {
        await setIsLoading(true)
        let data = await ApiCall('/api/Login/LoginAuthentication', { UserId: ValidateId || '', source: source || '', RequestID: RequestID ||'' })
        if (data.status === 'SUCCESS') {
            SetSession('cookies', 'token', data.loginSessionID);
            SetSession('localStorage', 'theme', 'light');
            SetSession('cookies', 'loginUserType', data.loginUserType);
            SetSession('cookies', 'loginUserCode', data.userCode);
            SetSession('cookies', 'userName', data.userName);
            SetSession('cookies', 'user', data);
            const redirectPath = '/Dashboard/DealerDashboard';
            setTimeout(() => {
                setIsLoading(false);
                navigate(location.state || redirectPath);
                localStorage.setItem('ID', "1");
            }, 700);
        } else if (data.status === 'ERROR') {
            await setPageStatus(true)
            await setResponse(data)
            await setIsLoading(false)
        }
    }

    useEffect(() => {
        SetSession('cookies', 'token', '');
        SetSession('localStorage', 'theme', 'light');
        SetSession('cookies', 'loginUserType', '');
        SetSession('cookies', 'loginUserCode', '');
        SetSession('cookies', 'userName', '');
        SetSession('cookies', 'user', '');
        if (ValidateId)
            AuthenticateSSOLogin()
    }, [ValidateId]);

    return (
        <>
            {isLoading && <Loader />}
            {ValidateId !== null && pageStatus ?
                <section className="py-3">
                    <div className="container">
                        <div className="row pt-5 mt-5">
                            <div className="col-12 text-center">
                                <div className="thankyou-img">
                                    <img
                                        src="./images/fail.png"
                                        className="img-fluid"
                                        style={{ maxWidth: 150 }}
                                        alt='...'
                                    />
                                </div>
                                <div className="thankyou-text mt-3">
                                    <h3 className="text-danger fw-bold">{"ERROR"}</h3>
                                    <p>
                                        {/*<span className='fs-6'>{Response.message}</span>*/}
                                        <span style={{
                                            fontWeight: 'bolder',
                                            fontFamily: 'math'
                                        }} className="fs-6" dangerouslySetInnerHTML={{ __html: Response.message }} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section> : (ValidateId === '' || ValidateId === null || ValidateId === undefined) && <section className="py-3">
                    <div className="container">
                        <div className="row pt-5">
                            <div className="col-12 mb-5 text-center">
                                <div className="thankyou-img">
                                    <img src="./images/404.jpg" className="img-fluid" alt='' />
                                </div>
                                <div className="thankyou-text mt-5">
                                    <h3 className="main-heading h2">Page not found</h3>
                                    <p className='fs-6'>Dear Partner,</p><br/>
                                    <p className='fs-6'>We are unable to authenticate you due to the unavailability of your details. Please reach out to your Bajaj Sales representative for further assistance.</p><br/>
                                    <p className='fs-6'>Thank you for your understanding.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>}
        </>
    );
};
export default Authenticate;